<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
  overflow-x: hidden;
  display: block !important;
}

body {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 !important;
  padding: 0 !important;
}

.begin {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
